module.exports = __webpack_public_path__ + "img/code-1.f5bca97a.png";